export function generateSimpleID(length = 12) {
    return [...Array(length)].map(() => Math.floor(Math.random() * 36).toString(36)).join('');
}
